import React from "react";
import { Route, Navigate } from "react-router-dom";
import Protected from "../components/Protected";
import AdminProtected from "../components/AdminProtected";
import Clients from "../pages/Admin-pages/clientPages/Clients";
// import ClientProjects from "../pages/Admin-pages/clientPages/ClientProjects";
import ClientInfo from "../pages/Admin-pages/clientPages/ClientInfo";
// import ClientSub from "../pages/Admin-pages/clientPages/ClientSub";

import ModuleAdd from "../pages/Admin-pages/clientPages/ModuleAdd";

import ModuleDetails from "../pages/Admin-pages/clientPages/ModuleDetails";
import ClientRelationships from "../pages/Admin-pages/clientPages/ClientRelationships";
// eslint-disable-next-line no-unused-vars
// import ClientAdd from "../pages/Admin-pages/clientPages/ClientAdd";
import ClientProjects from "../pages/Admin-pages/clientPages/ClientProjects";
import SettingsNaics from "../pages/Admin-pages/SettingsPages/SettingsNaics";
import ContactAdd from "../pages/Admin-pages/clientPages/ContactAdd";
import ClientSub2 from "../pages/Admin-pages/clientPages/ClientSub2";
import ContactEdit from "../pages/Admin-pages/clientPages/ContactEdit";
import ModuleNewAccess from "../pages/Admin-pages/clientPages/ModuleNewAccess";
import Modules from "../pages/Admin-pages/clientPages/Modules";
import LoginSettings from "../pages/Admin-pages/clientPages/LoginSettings";
import ImpersonateLogin from "../pages/ImpersonateLogin";
import ImpersonateCheck from "../components/ImpersonateCheck";
import ImpersonateSwitchBack from "../pages/ImpersonateSwitchBack";
import {
  getUpdateStatus1,
  getViewStatus1,
} from "../components/AdminComponents/ViewUpdateIndexTnAdmin";
import { useSelector } from "react-redux";
import ClientApiAdd from "../pages/Admin-pages/clientPages/ClientApiAdd";
import ImpersonateUserLogin from "../pages/ImpersonateUserLogin";
import LmsPurchaseSub from "../pages/Admin-pages/clientPages/LmsPurchaseSub";

const AdminManagerRoutes = () => {
  const userInfo = useSelector((state) => state?.user);
  const routes = [
    <Route
      key="manager-route-1"
      path="/admin-manager/clients"
      element={
        <Protected>
          <AdminProtected access={true}>
            <Clients />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-2"
      path="/admin-manager/clients/add-user"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus1(userInfo, 0, 0)}>
            <ClientProjects />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-3"
      path="/admin-manager/clients/profile/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 0)}>
            <ClientInfo />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="manager-route-54343"
      path="/admin-manager/clients/sub/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 1)}>
            <ClientSub2 />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-532"
      path="/admin-manager/clients/sub/:id/lms/:p_id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 1)}>
            <LmsPurchaseSub />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-111"
      path="/admin-manager/clients/relationships/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 2)}>
            <ClientRelationships />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-1aa2"
      path="/admin-manager/clients/login-settings/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 3)}>
            <LoginSettings />
          </AdminProtected>
        </Protected>
      }
    />,
    // NEW ROUTE - API
    <Route
      key="manager-route-1aa33"
      path="/admin-manager/clients/api/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 0, 4)}>
            <ClientApiAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    // End Route
    <Route
      key="manager-route-110"
      path="/admin-manager/clients/relationships/:r_id/add-contact/:id/"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus1(userInfo, 0, 2)}>
            <ContactAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-100"
      path="/admin-manager/clients/relationships/:r_id/edit-contact/:id/:mainID"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus1(userInfo, 0, 2)}>
            <ContactEdit />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-56"
      path="/admin-manager"
      element={<Navigate to="/admin-manager/clients/" />}
    />,

    <Route
      key="manager-route-7"
      path="/admin-manager/modules"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 1, 0)}>
            <Modules />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="setting-route-2"
      path="/admin-manager/setting-naics"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 2, 0)}>
            <SettingsNaics />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="manager-route-8"
      path="/admin-manager/modules/add-user"
      element={
        <Protected>
          <AdminProtected access={getUpdateStatus1(userInfo, 1, 0)}>
            <ModuleAdd />
          </AdminProtected>
        </Protected>
      }
    />,
    <Route
      key="manager-route-9"
      path="/admin-manager/modules/details/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 1, 0)}>
            <ModuleDetails />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="manager-route-1044"
      path="/admin-manager/modules/access/:id"
      element={
        <Protected>
          <AdminProtected access={getViewStatus1(userInfo, 1, 1)}>
            <ModuleNewAccess />
          </AdminProtected>
        </Protected>
      }
    />,

    <Route
      key="imp-01"
      path="/traineryone/client/impersonate/login"
      element={
        <ImpersonateCheck>
          <ImpersonateLogin />
        </ImpersonateCheck>
      }
    />,
    <Route
      key="imp-01--3232"
      path="/traineryone/user/impersonate/login"
      element={
        <ImpersonateCheck>
          <ImpersonateUserLogin />
        </ImpersonateCheck>
      }
    />,
    <Route
      key="imp-02"
      path="/traineryone/client/impersonate/switchback"
      element={
        <ImpersonateCheck>
          <ImpersonateSwitchBack />
        </ImpersonateCheck>
      }
    />,
  ];
  return routes;
};
export default AdminManagerRoutes;
